import React, { useState } from 'react';
import { Button, Stack, Text } from '@cad-arc';

/** Lines shown before the rest fold behind "Show all". */
export const EXPLANATION_VISIBLE_LINES = 6;

/**
 * What went into a recommendation, one line each, written by the recommendation engine and shown in its order.
 * The text is display-only and comes from the server as-is. Long lists fold after
 * {@link EXPLANATION_VISIBLE_LINES} lines so a large plan doesn't push the rest of the history out of view.
 */
export function ExplanationLines({ lines }: { lines: string[] }): React.ReactElement {
    const [isExpanded, setIsExpanded] = useState(false);
    const hiddenCount = lines.length - EXPLANATION_VISIBLE_LINES;
    const visibleLines = isExpanded || hiddenCount <= 0 ? lines : lines.slice(0, EXPLANATION_VISIBLE_LINES);

    return (
        <Stack spacing={0}>
            {visibleLines.map((line, idx) => (
                <Text key={idx}>{line}</Text>
            ))}
            {hiddenCount > 0 && (
                <Button
                    variant="ghost"
                    size="sm"
                    aria-expanded={isExpanded}
                    alignSelf="flex-start"
                    onClick={function toggleExplanation() {
                        setIsExpanded((expanded) => !expanded);
                    }}
                >
                    {isExpanded ? 'Show less' : `Show all (${lines.length})`}
                </Button>
            )}
        </Stack>
    );
}
